import { PlanData } from "./data";
import {
  GetStartedWrapper,
  PlanName,
  PlanNameWrapper,
  PlanPrice,
  PlanPriceTag,
  PrimaryGetStartedButton,
  SecondaryGetStartedButton,
  Table,
  TableCell,
  renderValue
} from "./styles";

const AllPlansTable: React.FC = () => {
  return (
    <Table>
      <thead>
        <tr>
          <TableCell as="th"></TableCell>
          {PlanData.plans.map(({ type, price, primary }, key) => (
            <TableCell key={key} as="th" $isPrimary={primary} $isHeader={true}>
              <PlanNameWrapper>
                <PlanName>{type}</PlanName>
                <PlanPrice>{price}</PlanPrice>
              </PlanNameWrapper>
            </TableCell>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          <TableCell>Usage</TableCell>
          {PlanData.plans.map(({ primary }, key) => (
            <TableCell key={key} $isPrimary={primary}></TableCell>
          ))}
        </tr>
        {PlanData.usage.map((attr, index) => (
          <tr key={index}>
            <TableCell>{attr}</TableCell>
            {PlanData.plans.map(({ usage, primary }, key) => (
              <TableCell key={key} $isPrimary={primary}>
                {renderValue(usage[index])}
              </TableCell>
            ))}
          </tr>
        ))}
      </tbody>
      <tbody>
        <tr>
          <TableCell>Features</TableCell>
          {PlanData.plans.map(({ primary }, key) => (
            <TableCell key={key} $isPrimary={primary}></TableCell>
          ))}
        </tr>
        {PlanData.features.map((attr, index) => (
          <tr key={index}>
            <TableCell>{attr}</TableCell>
            {PlanData.plans.map(({ features, primary }, key) => (
              <TableCell key={key} $isPrimary={primary}>
                {renderValue(features[index])}
              </TableCell>
            ))}
          </tr>
        ))}
      </tbody>
      <tbody>
        <tr>
          <TableCell>Support</TableCell>
          {PlanData.plans.map(({ primary }, key) => (
            <TableCell key={key} $isPrimary={primary}></TableCell>
          ))}
        </tr>
        {PlanData.support.map((attr, index) => (
          <tr key={index}>
            <TableCell>{attr}</TableCell>
            {PlanData.plans.map(({ support, primary }, key) => (
              <TableCell key={key} $isPrimary={primary}>
                {renderValue(support[index])}
              </TableCell>
            ))}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <TableCell></TableCell>
          {PlanData.plans.map(({ primary, getStartedUrl }, key) => (
            <TableCell key={key} $isPrimary={primary} $isFooter={true}>
              <GetStartedWrapper $isPrimary={primary}>
                {primary ? (
                  <>
                    <PrimaryGetStartedButton href={getStartedUrl}>Get Started</PrimaryGetStartedButton>
                    <p>Free, Open-Source Software</p>
                  </>
                ) : (
                  <>
                    <SecondaryGetStartedButton href={getStartedUrl}>
                      Schedule a Call
                    </SecondaryGetStartedButton>
                    <p>Get a Customized Demo</p>
                  </>
                )}
              </GetStartedWrapper>
            </TableCell>
          ))}
        </tr>
      </tfoot>
    </Table>
  );
};

export default AllPlansTable;
